/**
 * Step `acmi_references` (SA-1197, spec C11): the contract check and the cost
 * minimum's pre-fill, the cost sheet's total over its block hours. Pure: the
 * manifest imports `matchesRateReferences` eagerly.
 */
import type { TaskRead } from '@/types/process'
import { EXIT_DONE, F, carries, toNumber } from './contract'
import { halfUp } from './costSheet'

export const RATE_REFERENCES_FORM: readonly string[] = [F.costMinimum, F.utilisation, F.marketLow, F.marketHigh]

/** The four fields on the form, the `done` exit, nothing redacted (the two totals among the needs
 * included), no AI proposal; the cost minimum a number. */
export function matchesRateReferences(task: TaskRead): boolean {
  if (!carries(task, RATE_REFERENCES_FORM, [EXIT_DONE])) return false
  return task.form.find((f) => f.id === F.costMinimum)?.type === 'number'
}

/** The cost minimum the sheet implies: the direct operating cost over the block hours, to the
 * cent; null without both figures or with no hours. */
export function minimumFrom(needs: Record<string, unknown>): { value: number; doc: number; hours: number } | null {
  const doc = toNumber(needs[F.costEstimated])
  const hours = toNumber(needs[F.blockHours])
  if (doc === null || hours === null || hours <= 0) return null
  return { value: halfUp(doc / hours), doc, hours }
}
